import { UnifiedFieldType } from "./service";

/** Collapsed-row type badge text — rendered as a colored `TypeTag` pill in `FieldsScreen.tsx`
 *  (not a literal `[Type]` bracket string anymore, see that file's `TYPE_TAG_COLORS`). */
export const FIELD_TYPE_LABELS: Record<UnifiedFieldType, string> = {
  mapped: "Mapped",
  glossary: "Glossary",
};

/**
 * Collapsed-row subtitle — the comma-joined source list for a Mapped field with source(s)
 * picked (`"PlayUID, GameSegment"`), empty otherwise. The type itself is shown separately via a
 * `TypeTag` badge (see `FieldsScreen.tsx`), not folded into this string anymore — Glossary rows
 * have no source concept, so they always summarize to nothing here. Mapping's old mode indicator
 * (Direct/Substitute/Format) is intentionally NOT part of this subtitle either — a field's
 * flattened type/mode is what the row's own `TypeTag`/type `Select` communicate. `ruleCount`
 * covers Conditional mode, which has no `sources` list of its own to summarize.
 */
export const summarizeRow = (
  type: UnifiedFieldType,
  sources: string[],
  sourceLabel: (key: string) => string,
  ruleCount?: number
): string => {
  if (type !== "mapped") {
    return "";
  }
  if (sources.length > 0) {
    return sources.map(sourceLabel).join(", ");
  }
  return ruleCount ? `${ruleCount} rule${ruleCount !== 1 ? "s" : ""}` : "";
};
